export default __webpack_public_path__ + "static/media/Montserrat-BoldItalic.dd8646a4.woff2";